import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Cache } from './classes/Cache';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BaseComponent } from './classes/BaseComponent';
import { HealthService } from './health.service';
import { StorageHelper } from './helpers/StorageHelper';
import { Location } from '@angular/common';
import { EventService } from './event.service';
import { Global } from './classes/Global';
import { ThemeService } from './theme.service';
import { InfoService } from './info.service';
import { Log } from './helpers/Log';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ HealthService, EventService, InfoService ]
})
export class AppComponent extends BaseComponent implements OnInit{

  previousUrl: string = "";

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private healthService: HealthService,
    private location: Location,
    private eventService: EventService,
    private themeService: ThemeService,
    private infoService: InfoService
  ){

    super();

    this.themeService.updateTheme();

    from(this.router.events).pipe(
    filter(e => e instanceof NavigationEnd))
    .subscribe((e: NavigationEnd) => {

      const cache = Cache.getInstance();
      cache.addUrlsToHistory(cache.getCurrentUrl(this));
      cache.setCurrentUrl(e["url"]);
      if (e.url.includes("/404") && this.previousUrl && !this.previousUrl.includes("/404")) {
        if((<any>window).gtag) {
          (<any>window).gtag('event', "404Redirect", {
            'event_category': "PageAnalysis",
            'event_label': this.previousUrl
          });
         }
        if ((<any>window)._paq) {
          (<any>window)._paq.push(['trackEvent', '404Redirect', this.previousUrl]);
        }
        this.infoService.set404Info(this.previousUrl).subscribe(res =>{}, err =>{});
      }

      this.previousUrl = e.url;

      //Track pageview in Matomo
      if ((<any>window)._paq) {
        (<any>window)._paq.push(['trackEvent', 'pageview', e.urlAfterRedirects]);
      }

      //Log in Google Analytics
      if((<any>window).gtag) { (<any>window).gtag('set', 'page', e.urlAfterRedirects); }
      if((<any>window).gtag) { (<any>window).gtag('pageview'); }
    });

    this.route.queryParams.subscribe(queryParams => {

      if(queryParams['lang']) {
        StorageHelper.getInstance().save(StorageHelper.keys.lang, queryParams['lang']);
      }

      if (queryParams["mail"] == "1") {
        if((<any>window).gtag) {
          (<any>window).gtag('event', "EmailClick", {
            'event_category': "EmailMarketing"
          });
        }
        if ((<any>window)._paq) {
          (<any>window)._paq.push(['trackEvent', 'EmailMarketing', "EmailClick"]);
        }
      }
      if (queryParams["clickId"]) {
        this.eventService.newMailClick(Global.getStore(), Global.getCountry(), queryParams["clickId"]).subscribe(
          () => {
            // Success - event tracked
          },
          (err) => {
            // Silently handle errors - network issues shouldn't break the app
            // Status 0 errors (network/CORS/timeout) are already filtered by ErrorHandler
            Log.getInstance().d("Failed to track mail click event: " + (err.message || String(err)));
          }
        );
        const newUrl = this.router.url.split('?')[0];
        let newParams = "?";
        for (const qP of Object.keys(queryParams)) {
          if (qP != "clickId") {
            newParams += (qP + "=" + queryParams[qP] + "&");
          }
        }
        newParams = newParams == "?" ? "" : newParams.substr(0, newParams.length - 1);// remove last '&'
        if(this.location && newUrl) {
          const targetUrl = newUrl + newParams;
          // Only replace state if URL actually changed to prevent excessive replaceState calls
          if (this.location.path() !== targetUrl) {
            this.location.replaceState(targetUrl);
          }
        }
        if(!newUrl) {
          Log.getInstance().d("newUrl was null.");
        }

      }
    });

  }

  ngOnInit() {

    this.healthService.getWebsiteHealth().subscribe(res => {
      if (res && res['showDownScreen'] == "1") {
        StorageHelper.getInstance().save(StorageHelper.keys.downScreenMessage, res['downScreenMessage']);
        //The server is down, redirect to the 'down' page
        this.router.navigate([this.getCountry() + '/down']);
      }
    }, err => {

    });

  }

}
